import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams } from 'src/app/models';
import { ApiProductsService, DatetimeService } from 'src/app/services';

@Component({
  selector: 'app-donwload-file-from-storage',
  templateUrl: './donwload-file-from-storage.component.html',
  styleUrls: ['./donwload-file-from-storage.component.css']
})
export class DonwloadFileFromStorageComponent implements OnInit {


  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  files: File[] = [];


  form: UntypedFormGroup = this.fb.group({
    file: [null]
  })

  constructor(
    public activeModal: NgbActiveModal,
    public fb: UntypedFormBuilder,
    private apiProducts: ApiProductsService,
    private dateTimeService: DatetimeService

  ) { }

  ngOnInit(): void {

    this.getStorageFiles();

  }


  /**
   * 
   */
  getStorageFiles(): void {

    let params: ReferenceParams = {
      ref_name: 'file',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("FILES STORAGE LIST: ", response);


        if (response != null) {

          this.files = response;

        }
      })
    );

  }

  /**
   * 
   */
  sendData() {

    let obj = {
      id: this.form.get('file').value.id,
      name: this.form.get('file').value.name,
      link: this.form.get('file').value.link,
      date: this.form.get('file').value.meta.valid_to
    }
  
    this.activeModal.close(obj);

  }
}
